<template>
  <section class="all-teachers-section">
    <div class="all-teachers-filter-wrapper">
      <!--<search-courses  :is-teacher="true"></search-courses>-->
      <!--<form action="">-->
      <!--<b-form-input v-model="search" placeholder="Name"></b-form-input>-->
      <!--<v-select-->
      <!--placeholder="Subject"-->
      <!--:options="['Canada', 'United States']"-->
      <!--&gt;</v-select>-->
      <!--<v-select-->
      <!--placeholder="Std"-->
      <!--:options="['Canada', 'United States']"-->
      <!--&gt;</v-select>-->
      <!--<div class="btn-container">-->
      <!--<b-button size="lg" variant="primary"-->
      <!--&gt;Search Now-->
      <!--<font-awesome-icon class="ml-3" icon="search"></font-awesome-icon>-->
      <!--</b-button>-->
      <!--</div>-->
      <!--</form>-->
    </div>
    <h4 class="title">All Teachers</h4>
    <div class="following-wrapper">
      <div
        class="following-item"
        v-for="teacher in getAllTeachers"
        :key="teacher.teacher_id"
      >
        <teacher-card :teacher-data="teacher"></teacher-card>
      </div>
      <div class="following-item" @click="redirectToReg">
        <div class="becomeateacher-button">
          <b-img src="/img/icons/png/point4-white.png"></b-img>
          <span>Become a Teacher</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import TeacherCard from "../components/Templates/TeacherCard";
import { mapGetters } from "vuex";
import SearchCourses from "../components/Search/searchCourses";

export default {
  components: {
    SearchCourses,
    TeacherCard
  },
  name: "all-teachers",
  computed: {
    ...mapGetters("teacher", ["getAllTeachers"])
  },
  data() {
    return {
      search: ""
    };
  },
  methods: {
    redirectToReg() {
      this.$router.push("/become_a_teacher");
    }
  }
};
</script>

<style scoped></style>
